import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth.service';

export const adminGuard: CanActivateFn = (route, state) => {
  console.log('running adminGuard on ', route.url, state);
  return inject(AuthService).isGranted('Administrators');
};
